module.exports = __webpack_public_path__ + "img/connection.93af9f6b.png";